const Style = {

    base: 'relative pb-5 mb-5 border-dotted border-slate-100 border-b',
    flex: 'overflow-visible flex items-center justify-between gap-2 max-[660px]:flex-col max-[660px]:items-start max-[660px]:gap-5'
  
  }
  
  export default Style